import React from 'react';
import { CHAT_AUTHOR_COLORS } from '../../platform/chatAuthorColors';
import './ChatColorPicker.css';

function ChatColorPicker({ value, fallbackColor, onChange, label = 'Barva v klepetu' }) {
  const selectedColor = value || fallbackColor;

  return (
    <div className="chat-color-picker">
      <div className="chat-color-picker__label">{label}</div>
      <div className="chat-color-picker__options" role="radiogroup" aria-label={label}>
        {CHAT_AUTHOR_COLORS.map((color) => {
          const isSelected = selectedColor === color;
          return (
            <button
              key={color}
              type="button"
              role="radio"
              aria-checked={isSelected}
              aria-label={`Barva ${color}`}
              className={`chat-color-picker__swatch${isSelected ? ' chat-color-picker__swatch--selected' : ''}`}
              style={{ backgroundColor: color }}
              onClick={() => onChange(color)}
            />
          );
        })}
      </div>
      <div className="chat-color-picker__hint">
        Ta barva se prikaže ob vašem imenu in avatarju v skupinskih klepetih.
      </div>
    </div>
  );
}

export default ChatColorPicker;
